import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-hero-section',
  templateUrl: './hero-section.component.html',
  styleUrls: ['./hero-section.component.scss'],
  standalone: true
})
export class HeroSectionComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.initAnimations();
  }

  navigateToHome(): void {
    window.location.href = '/#/home';
  }
  navigateToLogin(): void {
    window.open('/#/login/insurer', '_blank');
  }

  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  private initAnimations(): void {
    // Hero title animation
    setTimeout(() => {
      const heroTitle = document.querySelector('.hero-title');
      if (heroTitle) {
        heroTitle.classList.add('hero-animate');
      }
    }, 500);

    // Hero image animation
    setTimeout(() => {
      const heroImage = document.querySelector('.hero-image-section');
      if (heroImage) {
        heroImage.classList.add('hero-animate');
      }
    }, 800);

    // Floating chips animation
    setTimeout(() => {
      const chips = document.querySelectorAll('.floating-chip');
      chips.forEach((chip, index) => {
        setTimeout(() => {
          chip.classList.add('animate-in');
        }, index * 200);
      });
    }, 1000);
  }
}
